import account from "./RU/account.json"
import aiDiagnose from "./RU/aiDiagnose.json"
import allCarManage from "./RU/allCarManage.json"
import base from "./RU/base.json"
import bookingManagement from "./RU/bookingManagement.json"
import common from "./RU/common.json"
import contractManagement from "./RU/contractManagement.json"
import dataManage from "./RU/dataManage.json"
import home from "./RU/home.json"
import homeMap from "./RU/homeMap.json"
import moveCarManage from "./RU/moveCarManage.json"
import orderManage from "./RU/orderManage.json"
import ordersManage from "./RU/ordersManage.json"
import index from "./RU/index.json"
import menu from "./RU/menu.json"
import newCommon from "./RU/newCommon.json"
import paper from "./RU/paper.json"
import shopOrder from "./RU/shopOrder.json"
import statistics from "./RU/statistics.json"
import statisticsIndex from "./RU/statisticsIndex.json"
import storeManagement from "./RU/storeManagement.json"
import tdms from "./RU/tdms.json"
import teamManage from "./RU/teamManage.json"
import stock from "./RU/stock.json"
import settings from "./RU/settings.json"
import purchase from "./RU/purchase.json"
import shopping from "./RU/shopping.json"
import sale from "./RU/sale.json"
import quickBilling from "./RU/quickBilling.json"
import components from "./RU/components.json"
import erpcomponents from "./RU/erpcomponents.json"
import orgManage from "./RU/orgManage.json"
import customerManage from "./RU/customerManage.json"
import dataDictionaries from "./RU/dataDictionaries.json"
import login from "./RU/Login.json"
import logs from "./RU/logs.json"
import permission from "./RU/permission.json"
import utils from "./RU/utils.json"




const ruRU = {
  translation: {
    utils,
    permission,
    logs,
    login,
    common,
    index,
    menu,
    aiDiagnose,
    bookingManagement,
    allCarManage,
    contractManagement,
    dataManage,
    home,
    homeMap,
    moveCarManage,
    orderManage,
    ordersManage,
    teamManage,
    tdms,
    storeManagement,
    statisticsIndex,
    statistics,
    shopOrder,
    account,
    base,
    paper,
    newCommon,
    stock,
    settings,
    purchase,
    shopping,
    sale,
    quickBilling,
    components,
    erpcomponents,
    orgManage,
    customerManage,
    dataDictionaries
  }
};

export default ruRU;
